export default api => ({
    list: params => api.get('/imports', params),
    listRecords: params => api.get('/imports/records', params),
    files: (params, options) => api.post('/imports/files', params, options),
    filesMultiEntity: (params, options) => api.post('/imports/files/multi-entity', params, options),
    create: (params, options) => api.post('/imports', params, options),
    get: id => api.get(`/imports/${id}`),
    getJsonComparator: id => api.get(`/records/${id}/compare`),
    confirmValidation: (id, params) => api.patch(`/api/records/${id}/status`, params),
    remove: id => api.delete(`/imports/${id}`),
    update: (id, params) => api.put(`/imports/${id}`, params),

    save: (id, params) => api.put(`/imports/${id}/confirm`, params),
    cancel: id => api.put(`/imports/${id}/cancel`, {}),

    getSource: (id, params) => api.get(`/imports/${id}/source`, params),
    editSource: (id, params) => api.put(`/imports/${id}/source`, params),
    deleteSource: (id, params) => api.delete(`/imports/${id}/source`, params),
    /* Es necesario el "responseType: 'blob'" para poder descargar el fichero.
     * con la codificación adecuada.
     * El parámetro "params" no tiene nada pero es necesario para poder llegar al siguiente parámetro.
     */
    importDownload: (id, params) => api.get(`/imports/files/${id}/download`, params, { responseType: 'blob' }),
})
